/*
 * Which bundle is on screen.
 *
 * # Why this exists
 *
 * A till is installed by replacing files on a board and restarting a wrapper,
 * and until now nothing on the screen could say whether that worked. The
 * failure is silent in the worst way: the window opens, the shop name is
 * right, the cashier sells all day — on the previous build. It has happened
 * both directions here. A bundle was copied to the board and the old one kept
 * loading from a cached path; separately, a device reported a version the
 * release channel had never offered, so "it updated" was believed for a day
 * on no evidence.
 *
 * So the question "which build is this" must be answerable from the counter,
 * by a person looking at the screen, with no shell and no network. That is the
 * whole job of this file.
 *
 * # Why a compiled-in constant
 *
 * __TILL_BUILD__ is substituted by Vite at build time from `git describe`
 * (see vite.config.ts). A constant cannot disagree with the bundle it was
 * compiled into — which is exactly the property a version readout needs, and
 * exactly what a value fetched at runtime, or read from an environment
 * variable someone has to remember to pass, does not have.
 */
declare const __TILL_BUILD__: string | undefined;

/*
 * The guard is for vitest and for any consumer that loads this module without
 * Vite's define in place: an undeclared identifier would throw a ReferenceError
 * at import time and take the whole screen down, which is an absurd price for a
 * line of diagnostic text.
 */
export const tillBuild: string =
  typeof __TILL_BUILD__ === 'string' && __TILL_BUILD__ !== '' ? __TILL_BUILD__ : 'unknown';
